<template>
  <div class="layout-container">
    <van-nav-bar fixed v-if="$route.path!=='/user'">
      <template #left>
        <div class="logo"></div>
      </template>
      <template #right>
        <!-- <van-button
          @click="$router.push('/search')"
          class="search-btn"
          round
          type="info"
          size="small"
          icon="search">
          搜索
        </van-button> -->
      </template>
    </van-nav-bar>

    <router-view></router-view>

    <van-tabbar route>
      <!-- <van-tabbar-item to='/' icon="home-o">首页</van-tabbar-item> -->
      <van-tabbar-item to='/question' icon="orders-o">采购单</van-tabbar-item>
      <van-tabbar-item to='/task' icon="coupon-o">任务</van-tabbar-item>
      <van-tabbar-item to='/user' icon="user-o">我的</van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
export default {

}
</script>

<style lang='scss' scoped>
.layout-container {
    padding-top: 46px;
  .van-nav-bar{
    background-color: #5babfb;
  }
  // logo区域
  .logo {
    background: url("~@/assets/kungfubylogo.png") no-repeat;
    background-size: cover;
    width: 150px;
    height: 30px;
  }
  // 搜索按钮
  .search-btn {
    background-color: #5babfb;
    width: 100px;
    font-size: 14px;
    .van-icon {
      color: #fff;
    }
  }
}

</style>
